import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=4222b18c&scoped=true&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"
import style0 from "./radio.vue?vue&type=style&index=0&id=4222b18c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222b18c",
  null
  
)

export default component.exports